<template>
  <div v-if="portal && portal.type">
    <form v-if="portal.type == 'online' || portal.type =='delivery'" data-vv-scope="new">
      <span
        class="text-danger text-sm"
        v-show="errors.has('new.portal_username')"
      >{{ errors.first('new.portal_username') }}</span>
      <br />
      <label class="vs-input--label">Username</label>
      <vx-input-group class="mb-base">
        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="portal_username"
          v-model="localPortal.username"
          placeholder="Username"
        />
        <template slot="append">
          <div class="append-text bg-primary">
            <span>@venue_{{portal.venue_id || localPortal.venue_id}}</span>
          </div>
        </template>
      </vx-input-group>
      <span
        class="text-danger text-sm"
        v-show="errors.has('new.portal_password')"
      >{{ errors.first('new.portal_password') }}</span>
      <vx-input-group class="mb-base">
        <label class="vs-input--label">Password</label>
        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="portal_password"
          v-model="localPortal.password"
          placeholder="Password"
        />
      </vx-input-group>
      <vx-input-group class="mb-base" v-if="portal.type=='online'">
        <label class="vs-input--label">Role</label>
        <v-select
          v-model="localPortal.role"
          :options="roleOptions"
          :clearable="false"
          name="portal_role"
        />
      </vx-input-group>
      <label class="vs-input--label" v-if="portal.role && portal.role.value=='kiosk'">Last Active Duration</label>
      <vx-input-group class="mb-base" v-if="portal.role && portal.role.value=='kiosk'">
        <vs-input
          data-vv-validate-on="blur"
          name="portal_duration"
          v-model="localPortal.duration"
          type="number"
          placeholder="15"
        />
        <template slot="append">
          <div class="append-text bg-primary">
            <span>mins</span>
          </div>
        </template>
      </vx-input-group>
      <div class="vx-row">
        <div class="vx-col mr-auto">
          <vs-button @click.prevent="add()">Save</vs-button>
        </div>
      </div>
    </form>
    <form v-if="portal.type == 'device'" data-vv-scope="device">


      <vx-input-group class="mb-base">

      <label class="vs-input--label">Device #</label>
      <vs-input
        name="portal_device"
        class="inputx mb-3"
        placeholder="Device ID"
        v-model="localPortal.device_id"
        data-vv-validate-on="blur"
        v-validate="'required'"
      />
      <span class="text-danger text-sm">{{ errors.first('device.portal_device') }}</span>
      <!-- <br>
        <label class="vs-input--label">Capabilities</label>
        <vs-input
          data-vv-validate-on="blur"
          v-validate="{ regex:/^(?!,)(,?[0-9]+)+$/ }"
          name="capabilities"
          type="text"
          v-model="localPortal.capabilities"
          placeholder="22,23"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('device.capabilities')"
        >{{ errors.first('device.capabilities') }}</span> -->
      </vx-input-group>

      <vs-button color="primary" @click="add()" type="filled">Save</vs-button>
    </form>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { _savePortal, _updatePortal } from "@/services/Venue";
export default {
  components: {
    vSelect,
  },
  props: {
    roleOptions: Array,
  },
  data() {
    return {
      localPortal: {
        username: '',
        password: '',
        role: null,
        duration: 15,
        device_id: '',
        capabilities: ''
      }
    }
  },
  computed: {
    portal: {
      get() {
        // Ensure portalModule exists, return empty object if not
        if (!this.$store.state.portalModule) {
          return {}
        }
        return this.$store.state.portalModule
      },
    },
  },
  watch: {
    portal: {
      handler(newVal) {
        if (newVal && newVal.type) {
          // Sync local data with store when portal changes
          this.localPortal = {
            username: newVal.username || '',
            password: newVal.password || '',
            role: newVal.role || null,
            duration: newVal.duration || 15,
            device_id: newVal.device_id || '',
            capabilities: newVal.capabilities || ''
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  // beforeDestroy() {
  //   this.$validator.pause();
  // },
  methods: {
    add() {
      if (!this.portal || !this.portal.type) {
        return
      }
      // Update store with local data before saving
      this.$store.dispatch('portalModule/updatePortal', {
        ...this.portal,
        ...this.localPortal
      })
      
      if (this.portal.type == "device") {
        this.$validator.validateAll("device").then((result) => {
          if (result) {
            this.$vs.loading();
            if (this.portal.id) this.doUpdate();
            else this.doSave();
          }
        });
      } else {
        this.$validator.validateAll("new").then((result) => {
          if (result) {
            this.$vs.loading();
            if (this.portal.id) this.doUpdate();
            else this.doSave();
          }
        });
      }
    },
    doSave() {
      _savePortal(this.portal.venue_id, this.portal)
        .then(
          (response) => {
            this.handleSuccess(
              response.data.responseTitle,
              response.data.responseMessage
            );
            this.$emit("addParentPortal", response);
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((err) => {
          this.handleCatch(err);
        })
        .finally(() => this.$vs.loading.close());
    },

    doUpdate() {
      this.$vs.loading();
      let venue_id = this.portal.venue_id;
      let portal_id = this.portal.id;

      _updatePortal(venue_id, portal_id, this.portal)
        .then(
          (response) => {
            this.handleSuccess(
              response.data.responseTitle,
              response.data.responseMessage
            );
            this.$emit("updateParentPortal", response, "edit");
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => this.$vs.loading.close());
    },

    handleSuccess(title, msg) {
      this.$vs.notify({
        title: title,
        text: msg,
        iconPack: "feather",
        icon: "icon-check-circle",
        color: "success",
      });
      this.errors.clear();
    },

    handleError(error) {
      if (error.response.status == 422) {
        if (this.portal && this.portal.type == "device") {
          this.errors.add({
            scope: "device",
            field: "portal_device",
            msg: error.response.data["errors"].portal_device,
          });
        } else {
          this.errors.add({
            scope: "new",
            field: "portal_username",
            msg: error.response.data["errors"].portal_username,
          });
        }
      } else {
        this.$vs.notify({
          title: error.response.data.responseTitle,
          text: error.response.data.responseMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    },
    handleCatch(error) {
      this.$vs.notify({
        text: error.message,
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
  },
};
</script>
